import axios from 'axios';

// ORIGIN: https://testing-api.ecal.com/apiv3/ip/location?apiKey=iO4vouUk2ZQ1FvdIKIrlZGdTSztVhkTcBhdRJkIxLX86242a0b
const IP_LOCATION_URLS = {
    local:     'https://testing-api.ecal.com/apiv3/ip/location?apiKey=5gZW7HlqrrPfXI1bnUGbZPLrvyZMniBTTsizQoRv6s627c6dfe',
    devlocal:  'https://testing-api.ecal.com/apiv3/ip/location?apiKey=5gZW7HlqrrPfXI1bnUGbZPLrvyZMniBTTsizQoRv6s627c6dfe',
    test:      'https://testing-api.ecal.com/apiv3/ip/location?apiKey=5gZW7HlqrrPfXI1bnUGbZPLrvyZMniBTTsizQoRv6s627c6dfe',
    stage:     'https://staging-api-cdn.ecal.com/apiv3/ip/location?apiKey=5b3ba2e65690b8790a7b61ef848692df57a40b538a95f',
    prod:      'https://api-cdn.ecal.com/apiv3/ip/location?apiKey=6ea0955297341b6b22f516a42177979d55821c6d7217b',
};

function getIPLocationURL() {
    return IP_LOCATION_URLS[window.env] || IP_LOCATION_URLS.prod;
}

// Pure fetch — no store mutation. External geo-IP provider, called directly
// with axios (not the internal manage-my-ecal-bff client) since it's an
// unrelated third-party endpoint with its own apiKey scheme.
export async function getIPLocation() {
    const url = getIPLocationURL();
    let data = {};
    try {
        const res = await axios.get(url);
        data = res.data;
    } catch (err) {
        // caller falls back to whatever timezone/location it already has
    }

    return {
        ip: data.ip || '',
        country: data.country_code || '',
        countryCode: data.country_code || '',
        countryName: data.country_name || '',
        timezone: data.timezone || '',
        city: data.city_name || '',
        state: data.state_name || '',
        postal: data.zip_code || '',
    };
}

export default getIPLocation;
